import { useSearchParams } from 'react-router-dom-latest';

export default function useOverlays() {
  const [searchParams] = useSearchParams();
  return searchParams.getAll('overlay');
}
